import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
};

const MoreOptionsIcon = ({ color = '#B5BCBD', ...props }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="8px"
    height="20px"
    viewBox="0 0 8 20"
    {...props}
  >
    <g fill={color}>
      <path d="M6,16 C7.1,16 8,16.9 8,18 C8,19.1 7.1,20 6,20 C4.9,20 4,19.1 4,18 C4,16.9 4.9,16 6,16 L6,16 Z M6,14 C4.9,14 4,13.1 4,12 C4,10.9 4.9,10 6,10 C7.1,10 8,10.9 8,12 C8,13.1 7.1,14 6,14 L6,14 Z M6,8 C4.9,8 4,7.1 4,6 C4,4.9 4.9,4 6,4 C7.1,4 8,4.9 8,6 C8,7.1 7.1,8 6,8 L6,8 Z" />
    </g>
  </svg>
);

MoreOptionsIcon.propTypes = propTypes;

export default MoreOptionsIcon;
